"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ = require("../");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

class LayoutInbox extends _react.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "renderHeader", () => {
      const _this$props = this.props,
            title = _this$props.title,
            parents = _this$props.parents;

      if (parents) {
        return _react.default.createElement(_.FinderHeader, null, _react.default.createElement(_.NavPath, {
          parents: parents
        }));
      }

      return _react.default.createElement(_.FinderHeader, null, _react.default.createElement(_.FinderTitle, {
        title: title
      }));
    });

    _defineProperty(this, "renderBody", () => {
      const _this$props2 = this.props,
            results = _this$props2.results,
            item = _this$props2.item;
      const style = {
        paddingLeft: 0,
        paddingRight: 0
      };

      if (this.props.children) {
        return _react.default.createElement(_.FinderBody, {
          style: style
        }, this.props.children);
      }

      if (item && item.uniqueId) {
        return _react.default.createElement(_.FinderBody, {
          style: style
        }, _react.default.createElement(_.InboxEditor, _extends({}, this.props, {
          formData: item
        })));
      }

      if (results) {
        return _react.default.createElement(_.FinderBody, {
          style: style
        }, _react.default.createElement(_.InboxResults, _extends({}, this.props, {
          results: results
        })));
      }

      return _react.default.createElement(_.FinderBody, {
        style: style
      }, this.props.children);
    });
  }

  render() {
    return _react.default.createElement(_.FinderBase, null, this.renderHeader(), this.renderBody());
  }

}

_defineProperty(LayoutInbox, "defaultProps", {});

LayoutInbox.propTypes = process.env.NODE_ENV !== "production" ? {
  /** Title */
  title: _propTypes.default.string,

  /** Parents */
  parents: _propTypes.default.array,

  /** Section */
  section: _propTypes.default.string,

  /** Category */
  category: _propTypes.default.string,

  /** Results */
  results: [],

  /** FormData */
  item: {}
} : {};
var _default = LayoutInbox;
exports.default = _default;
module.exports = exports.default;